module.exports = __webpack_public_path__ + "static/img/早班領班-桃青龍.890912e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/早班領班-桃青龍.jpg
// module id = phrj
// module chunks = 1